import { useEffect, useState } from 'react';
import { axios } from '@/lib/axios';

/**
 * CSRFトークンを管理するフック
 */
export const useCsrfToken = () => {
  const [csrfToken, setCsrfToken] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchCsrfToken = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get('/api/v1/csrf-token/getToken');
      const token = response.data.csrfToken;

      setCsrfToken(token);
      if (token) {
        sessionStorage.setItem('csrfToken', token);
      }

      return token;
    } catch (err) {
      const error = err instanceof Error ? err : new Error('CSRF token fetch failed');
      setError(error);
      console.error('Failed to fetch CSRF token:', error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const initToken = async () => {
      const existingToken = sessionStorage.getItem('csrfToken');
      if (existingToken) {
        setCsrfToken(existingToken);
        setLoading(false);
      } else {
        await fetchCsrfToken();
      }
    };

    initToken();
  }, []);

  return {
    csrfToken,
    loading,
    error,
    refetchToken: fetchCsrfToken,
  };
};
